import { Component, Input, OnChanges, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UrlSubstringWhitelist, Verb } from "@onsip/common/interfaces/organization-configuration";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "onsip-page-rule-view",
  templateUrl: "page-rule-view.component.html",
  styleUrls: ["../sayso-topic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PageRuleViewComponent implements OnChanges, OnInit {
  @Input() pages: UrlSubstringWhitelist = [];
  rules: UrlSubstringWhitelist = [];
  exceptions: UrlSubstringWhitelist = [];

  translatedVerbs: Record<Verb, string> = {} as Record<Verb, string>;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translatedVerbs[Verb.DOES_NOT_EQUAL] = this.translate.instant("ONSIP_I18N.DOES_NOT_EQUAL");
    this.translatedVerbs[Verb.DOES_NOT_INCLUDE] = this.translate.instant(
      "ONSIP_I18N.DOES_NOT_INCLUDE"
    );
    this.translatedVerbs[Verb.ENDS_WITH] = this.translate.instant("ONSIP_I18N.ENDS_WITH");
    this.translatedVerbs[Verb.EXACT] = this.translate.instant("ONSIP_I18N.EXACT");
    this.translatedVerbs[Verb.INCLUDES] = this.translate.instant("ONSIP_I18N.INCLUDES");
    this.translatedVerbs[Verb.STARTS_WITH] = this.translate.instant("ONSIP_I18N.STARTS_WITH");
  }

  ngOnChanges() {
    this.rules = [];
    this.exceptions = [];

    const ruleTypes: Array<Verb> = [Verb.INCLUDES, Verb.STARTS_WITH, Verb.ENDS_WITH, Verb.EXACT];
    const exceptionTypes: Array<Verb> = [Verb.DOES_NOT_INCLUDE, Verb.DOES_NOT_EQUAL];

    this.pages &&
      this.pages.forEach((page: [Verb, string]) => {
        if (ruleTypes.find(verb => verb === page[0])) this.rules.push(page);
        else if (exceptionTypes.find(verb => verb === page[0])) this.exceptions.push(page);
      });
  }
}
